import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Checkout2, ErrorPage } from "./pages";
import NewThankyouPage from "./pages/NewThankyouPage";
import { firePageView } from "./utils/ga4Tracking";

const GtmPageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    firePageView({
      pagePath: `${location.pathname}${location.search}`,
    });
  }, [location.pathname, location.search]);

  return null;
};

const App = () => {
  return (
    <>
      <BrowserRouter>
        <GtmPageTracker />
        <Routes>
          <Route path="/" element={<Checkout2 />} />
          <Route path="/payment" element={<Checkout2 />} />
          <Route path="*" element={<ErrorPage />} />
          <Route path="/ErrorPage" element={<ErrorPage />} />
          <Route path="/thankyou-page" element={<NewThankyouPage />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
